import React from "react";
import { Icon } from "./icon";

const columns = [
  {
    title: "Services",
    links: [
      { label: "Web development", href: "#services" },
      { label: "Mobile apps", href: "#services" },
      { label: "UI/UX design", href: "#services" },
      { label: "Cloud & DevOps", href: "#services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Our work", href: "#portfolio" },
      { label: "Process", href: "#process" },
      { label: "Team", href: "#team" },
    ],
  },
  {
    title: "Get started",
    links: [
      { label: "Contact us", href: "#contact" },
      { label: "Why Mercuri", href: "#features" },
      { label: "Client feedback", href: "#testimonials" },
    ],
  },
];

export const Footer = ({ data }) => {
  const socials = [
    { icon: "linkedin", label: "LinkedIn", url: data ? data.linkedin : "/" },
    { icon: "x", label: "X", url: data ? data.twitter : "/" },
    { icon: "facebook", label: "Facebook", url: data ? data.facebook : "/" },
    { icon: "youtube", label: "YouTube", url: data ? data.youtube : "/" },
  ];

  return (
    <footer id="footer" className="on-dark border-t border-white/10 bg-navy-950 text-white">
      <div className="container py-16">
        <div className="grid grid-cols-2 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="col-span-2 lg:col-span-4">
            <a href="#page-top" className="inline-flex" aria-label="Mercuri — back to top">
              <img src="img/mercuri_logo.png" alt="Mercuri" className="h-10 w-auto" />
            </a>
            <p className="mt-6 max-w-xs leading-relaxed text-white/50">
              A software engineering studio building web, mobile and cloud products that
              hold up in production.
            </p>

            <div className="mt-7 flex gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/12 bg-white/[0.04] text-white/60 transition-all duration-300 hover:-translate-y-0.5 hover:border-crimson-500 hover:bg-crimson-600 hover:text-white"
                >
                  <Icon name={social.icon} className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <nav key={column.title} className="lg:col-span-2" aria-label={column.title}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-white/40">
                {column.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-white/70 transition-colors duration-300 hover:text-crimson-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="col-span-2 lg:col-span-2">
            <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-white/40">
              Contact
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              {data && (
                <>
                  <li>
                    <a
                      href={`mailto:${data.email}`}
                      className="break-words transition-colors duration-300 hover:text-crimson-300"
                    >
                      {data.email}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`tel:${data.phone.replace(/\s/g, "")}`}
                      className="transition-colors duration-300 hover:text-crimson-300"
                    >
                      {data.phone}
                    </a>
                  </li>
                  <li className="leading-relaxed text-white/50">{data.address}</li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="hairline-dark my-12" />

        <div className="flex flex-col items-center justify-between gap-5 sm:flex-row">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} Mercuri. All rights reserved.
          </p>

          <a
            href="#page-top"
            className="inline-flex items-center gap-2 rounded-lg text-sm font-medium text-white/50 transition-colors duration-300 hover:text-white"
          >
            Back to top
            <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/12 bg-white/[0.04]">
              <Icon name="arrowUpRight" className="h-4 w-4" />
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};
